const googleStoreWidgetSelector = '#merchantwidgetiframe';
const googleStoreWidgetTitle = 'Calidad de la tienda de Google';

/**
 * Adds an accessible name to the iframe injected by the Google & YouTube app.
 * A title provided by a future app update is always preserved.
 *
 * @returns {boolean} Whether the widget iframe is present.
 */
function labelGoogleStoreWidget() {
  const iframe = document.querySelector(googleStoreWidgetSelector);
  if (!(iframe instanceof HTMLIFrameElement)) return false;

  if (!iframe.getAttribute('title')?.trim()) {
    iframe.setAttribute('title', googleStoreWidgetTitle);
  }

  return true;
}

function watchForGoogleStoreWidget() {
  if (labelGoogleStoreWidget()) return;

  const observer = new MutationObserver(() => {
    if (!labelGoogleStoreWidget()) return;
    observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchForGoogleStoreWidget, { once: true });
} else {
  watchForGoogleStoreWidget();
}
